import { useMutation, useQuery, useQueryClient, type UseMutationResult, type UseQueryResult } from '@tanstack/react-query'
import type { BillingPriceScheduleDto } from '@lib/dto/billing.dto'
import type { SchedulePriceInput } from '@lib/input/billing.input'
import { billingKeys } from '@/hooks/queryKeys'
import { opsPricingService } from '@/services/OpsPricingService'

export function usePriceSchedule(): UseQueryResult<BillingPriceScheduleDto> {
  return useQuery({ queryKey: billingKeys.prices(), queryFn: () => opsPricingService.schedule() })
}

/** Schedules a price change. Every billing view shows the next change, so all of billing refreshes. */
export function useSchedulePrice(): UseMutationResult<BillingPriceScheduleDto, Error, SchedulePriceInput> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input) => opsPricingService.schedulePrice(input),
    onSuccess: async (schedule) => {
      queryClient.setQueryData(billingKeys.prices(), schedule)
      await queryClient.invalidateQueries({ queryKey: billingKeys.all })
    },
  })
}
